module.exports = __webpack_public_path__ + "img/6b.a4c51f49.jpg";